import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b2debbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioCheck = _resolveComponent("RadioCheck")!
  const _component_Check = _resolveComponent("Check")!

  return (_openBlock(), _createElementBlock("button", {
    class: "checkbox",
    name: _ctx.name,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(['check', { selected: _ctx.selected, radio: _ctx.isRadio }])
    }, [
      (_ctx.isRadio)
        ? (_openBlock(), _createBlock(_component_RadioCheck, { key: 0 }))
        : (_openBlock(), _createBlock(_component_Check, { key: 1 }))
    ], 2 /* CLASS */),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 8 /* PROPS */, _hoisted_1))
}